import useDecorativePatternStyles, { PILL_OFFSETS } from './decorativePattern.styles';

const DecorativePattern = () => {
  const { classes } = useDecorativePatternStyles();

  const columns = [
    { track: classes.track0, pill: classes.pill0 },
    { track: classes.track1, pill: classes.pill1 },
    { track: classes.track2, pill: classes.pill2 },
    { track: classes.track3, pill: classes.pill3 },
  ];

  return (
    <div className={classes.root}>
      {columns.map(({ track, pill }) => (
        <div key={track} className={track}>
          {PILL_OFFSETS.map((top) => (
            <span key={top} className={pill} style={{ top }} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default DecorativePattern;
